import React from 'react'
// import { NavLink } from "react-router-dom"
import Carousel from "react-multi-carousel";
// import { Barchart } from '../components/barchart';
import { useMediaQuery } from 'react-responsive'
import "react-multi-carousel/lib/styles.css";
import walletmockup from '../assets/web-wallet-mockup.png';
import mobile from '../assets/mobile.png';


// const Desktop = ({ children }) => {
//     const isDesktop = useMediaQuery({ minWidth: 1180 })
//     return isDesktop ? children : null
// }

const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 1024 })
    return isMobile ? children : null
}



export function Index(props) {

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };


    return (
        <>

            <section id='home' className='home'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-10 mx-auto'>


                            <div className='welcome-screen'>
                                <em>BLOCKCHAIN SOLUTIONS</em>
                                <h1>The Next Generation Web 3.0 Wallet</h1>
                                <p className='mb-5'>Lightning Payments From Your Pocket</p>

                                <button className='button-default' data-bs-toggle="modal" data-bs-target="#staticBackdrop" rel='noreferrer' title='Watch Promo'>
                                    <i className="fa-regular fa-circle-play"></i>  Watch Promo
                                </button>
                                <Mobile>
                                    <a className='button-lined' rel='noreferrer' href='https://wallet.hydranet.ai' target='_blank' title='Launch Now'>
                                        <i className="fa-regular fa-chess-queen"></i>Launch Now
                                    </a>
                                </Mobile>

                                <div className="social-icons d-flex justify-content-center mt-5 pt-4">
                                    <a className="twitter" rel='noreferrer' href="https://twitter.com/" target="_blank">
                                        <i className="icon-social-twitter"></i>
                                    </a>
                                    <a className="discord" rel='noreferrer' href="https://discord.gg/hydranet" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 50 50">
                                            <path d="M 18.90625 7 C 18.90625 7 12.539063 7.4375 8.375 10.78125 C 8.355469 10.789063 8.332031 10.800781 8.3125 10.8125 C 7.589844 11.480469 7.046875 12.515625 6.375 14 C 5.703125 15.484375 4.992188 17.394531 4.34375 19.53125 C 3.050781 23.808594 2 29.058594 2 34 C 1.996094 34.175781 2.039063 34.347656 2.125 34.5 C 3.585938 37.066406 6.273438 38.617188 8.78125 39.59375 C 11.289063 40.570313 13.605469 40.960938 14.78125 41 C 15.113281 41.011719 15.429688 40.859375 15.625 40.59375 L 18.0625 37.21875 C 20.027344 37.683594 22.332031 38 25 38 C 27.667969 38 29.972656 37.683594 31.9375 37.21875 L 34.375 40.59375 C 34.570313 40.859375 34.886719 41.011719 35.21875 41 C 36.394531 40.960938 38.710938 40.570313 41.21875 39.59375 C 43.726563 38.617188 46.414063 37.066406 47.875 34.5 C 47.960938 34.347656 48.003906 34.175781 48 34 C 48 29.058594 46.949219 23.808594 45.65625 19.53125 C 45.007813 17.394531 44.296875 15.484375 43.625 14 C 42.953125 12.515625 42.410156 11.480469 41.6875 10.8125 C 41.667969 10.800781 41.644531 10.789063 41.625 10.78125 C 37.460938 7.4375 31.09375 7 31.09375 7 C 31.019531 6.992188 30.949219 6.992188 30.875 7 C 30.527344 7.046875 30.234375 7.273438 30.09375 7.59375 C 30.09375 7.59375 29.753906 8.339844 29.53125 9.40625 C 27.582031 9.09375 25.941406 9 25 9 C 24.058594 9 22.417969 9.09375 20.46875 9.40625 C 20.246094 8.339844 19.90625 7.59375 19.90625 7.59375 C 19.734375 7.203125 19.332031 6.964844 18.90625 7 Z M 18.28125 9.15625 C 18.355469 9.359375 18.40625 9.550781 18.46875 9.78125 C 16.214844 10.304688 13.746094 11.160156 11.4375 12.59375 C 11.074219 12.746094 10.835938 13.097656 10.824219 13.492188 C 10.816406 13.882813 11.039063 14.246094 11.390625 14.417969 C 11.746094 14.585938 12.167969 14.535156 12.46875 14.28125 C 17.101563 11.410156 22.996094 11 25 11 C 27.003906 11 32.898438 11.410156 37.53125 14.28125 C 37.832031 14.535156 38.253906 14.585938 38.609375 14.417969 C 38.960938 14.246094 39.183594 13.882813 39.175781 13.492188 C 39.164063 13.097656 38.925781 12.746094 38.5625 12.59375 C 36.253906 11.160156 33.785156 10.304688 31.53125 9.78125 C 31.59375 9.550781 31.644531 9.359375 31.71875 9.15625 C 32.859375 9.296875 37.292969 9.894531 40.3125 12.28125 C 40.507813 12.460938 41.1875 13.460938 41.8125 14.84375 C 42.4375 16.226563 43.09375 18.027344 43.71875 20.09375 C 44.9375 24.125 45.921875 29.097656 45.96875 33.65625 C 44.832031 35.496094 42.699219 36.863281 40.5 37.71875 C 38.5 38.496094 36.632813 38.84375 35.65625 38.9375 L 33.96875 36.65625 C 34.828125 36.378906 35.601563 36.078125 36.28125 35.78125 C 38.804688 34.671875 40.15625 33.5 40.15625 33.5 C 40.570313 33.128906 40.605469 32.492188 40.234375 32.078125 C 39.863281 31.664063 39.226563 31.628906 38.8125 32 C 38.8125 32 37.765625 32.957031 35.46875 33.96875 C 34.625 34.339844 33.601563 34.707031 32.4375 35.03125 C 32.167969 35 31.898438 35.078125 31.6875 35.25 C 29.824219 35.703125 27.609375 36 25 36 C 22.371094 36 20.152344 35.675781 18.28125 35.21875 C 18.070313 35.078125 17.8125 35.019531 17.5625 35.0625 C 16.394531 34.738281 15.378906 34.339844 14.53125 33.96875 C 12.234375 32.957031 11.1875 32 11.1875 32 C 10.960938 31.789063 10.648438 31.699219 10.34375 31.75 C 9.957031 31.808594 9.636719 32.085938 9.53125 32.464844 C 9.421875 32.839844 9.546875 33.246094 9.84375 33.5 C 9.84375 33.5 11.195313 34.671875 13.71875 35.78125 C 14.398438 36.078125 15.171875 36.378906 16.03125 36.65625 L 14.34375 38.9375 C 13.367188 38.84375 11.5 38.496094 9.5 37.71875 C 7.300781 36.863281 5.167969 35.496094 4.03125 33.65625 C 4.078125 29.097656 5.0625 24.125 6.28125 20.09375 C 6.90625 18.027344 7.5625 16.226563 8.1875 14.84375 C 8.8125 13.460938 9.492188 12.460938 9.6875 12.28125 C 12.707031 9.894531 17.140625 9.296875 18.28125 9.15625 Z M 18.5 21 C 15.949219 21 14 23.316406 14 26 C 14 28.683594 15.949219 31 18.5 31 C 21.050781 31 23 28.683594 23 26 C 23 23.316406 21.050781 21 18.5 21 Z M 31.5 21 C 28.949219 21 27 23.316406 27 26 C 27 28.683594 28.949219 31 31.5 31 C 34.050781 31 36 28.683594 36 26 C 36 23.316406 34.050781 21 31.5 21 Z M 18.5 23 C 19.816406 23 21 24.265625 21 26 C 21 27.734375 19.816406 29 18.5 29 C 17.183594 29 16 27.734375 16 26 C 16 24.265625 17.183594 23 18.5 23 Z M 31.5 23 C 32.816406 23 34 24.265625 34 26 C 34 27.734375 32.816406 29 31.5 29 C 30.183594 29 29 27.734375 29 26 C 29 24.265625 30.183594 23 31.5 23 Z"></path>
                                        </svg>
                                    </a>
                                    <a className="youtube" rel='noreferrer' href="https://youtube.com/@HydranetHDN" target="_blank">
                                        <i className="icon-social-youtube"></i>
                                    </a>
                                    <a className="facebook" rel='noreferrer' href="https://www.facebook.com/HydranetOfficial" target="_blank">
                                        <i className="icon-social-facebook"></i>
                                    </a>
                                    <a className="linkedin" rel='noreferrer' href="https://tr.linkedin.com/company/hydranet" target="_blank">
                                        <i className="icon-social-linkedin"></i>
                                    </a>
                                    <a className="reddit" rel='noreferrer' href="https://www.reddit.com/r/hydranet/" target="_blank">
                                        <i className="icon-social-reddit"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <section id='features' className='key-features-section py-5'>
                <div className='container pb-5'>
                    <div className='row align-items-center justify-content-between'>
                        <div className='col-lg-6 col-md-7'>
                            <div className='feature-column'>
                                <p className='sub-title'>THE FUTURE</p>
                                <h2>More than a Wallet. Elevate your crypto
</h2>
                                <p className='mb-5'>Our Web Wallet seamlessly operates on your desktop browser, as well as on mobile and tablet devices.

                                </p>
                                <div className='advanced-content mb-4'>
                                    <div className='icon-box'>
                                        <i className="fa-solid fa-wallet"></i>
                                    </div>
                                    <div className='content-box'>
                                        <h3>One Seed - Multiple Assets</h3>
                                        <p>Keep all your crypto assets in one secure location for effortless management.

                                        </p>
                                    </div>

                                </div>

                                <div className='advanced-content'>
                                    <div className='icon-box'>
                                        <i className="fa-solid fa-coins"></i>
                                    </div>
                                    <div className='content-box'>
                                        <h3>Lightning Payments</h3>
                                        <p>Experience the power of Lightning payments and transform your commerce experience.


                                        </p>
                                    </div>

                                </div>
                            </div>




                        </div>
                        <div className='col-lg-5 col-md-5 my-5 my-lg-0 animation-01'>
                            <img className='img-fluid' src={walletmockup} title='Hydranet Web3 Wallet' alt='Hydranet Web3 Wallet'></img>

                        </div>
                    </div>

                </div>
                <div className='container pb-5 d-none'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12'>
                            <div className='feature-column mb-5'>
                                <p className='sub-title'>FEATURES</p>
                                <h2>Why So Special?</h2>

                            </div>
                        </div>


                        <Carousel responsive={responsive} arrows={false} autoPlay={false}
                            autoPlaySpeed={2000} infinite={false}
                            transitionDuration={500} dotListclassName="custom-dot-list-style"
                            itemclassName="carousel-item-padding-40-px" draggable={true}
                            showDots={true}>


                            <div className='advanced-content-2 mb-4 carousel-item-padding-40-px'>
                                <div className='icon-box'>

                                    <i className="fa-solid fa-link"></i>
                                </div>
                                <div className='content-box'>
                                    <h3>Multi Chains</h3>
                                    <p>
                                        Hydranet Web Wallet also supports the Bitcoin network, unlike EVM wallets such as Metamask. Safely store your ERC-20 and BTC with just one seedphrase.


                                    </p>
                                </div>

                            </div>

                            <div className='advanced-content-2 mb-4'>
                                <div className='icon-box'>

                                    <i className="fa-solid fa-fire"></i>
                                </div>
                                <div className='content-box'>
                                    <h3>Off-chain TXs</h3>
                                    <p>With off-chain support, Hydranet Wallet performs cheaper and faster transfers than on-chain transactions and offers a scaling solution.


                                    </p>
                                </div>

                            </div>
                            <div className='advanced-content-2 mb-4'>
                                <div className='icon-box'>

                                    <i className="fa-solid fa-file-invoice-dollar"></i>
                                </div>
                                <div className='content-box'>
                                    <h3>Payments</h3>
                                    <p>Hydranet Wallet offers fast payment services with Lightning Network and Lithium Protocol. Create your invoice and get paid quickly.


                                    </p>
                                </div>

                            </div>
                            <div className='advanced-content-2 mb-4'>
                                <div className='icon-box'>

                                    <i className="fa-solid fa-bridge-circle-check"></i>
                                </div>
                                <div className='content-box'>
                                    <h3>Cheapest Bridging</h3>
                                    <p>Hydranet Wallet offers fast payment services with Lightning Network and Lithium Protocol. Create your invoice and get paid quickly.


                                    </p>
                                </div>

                            </div>

                            <div className='advanced-content-2 mb-4'>
                                <div className='icon-box'>

                                    <i className="fa-regular fa-window-restore"></i>
                                </div>
                                <div className='content-box'>
                                    <h3>Multi Devices</h3>
                                    <p>With seedphrase, you can access your wallet from any device with a browser and instantly see all your assets. Does not require installation.


                                    </p>
                                </div>

                            </div>
                        </Carousel>


                    </div>
                </div>
                <div className='container'>
                    <div className="row justify-content-center items">
                        <div className='col-lg-12'>
                            <div className='feature-column mb-5'>
                                <p className='sub-title'>WEB3 SOLUTIONS</p>
                                <h2>Key Features</h2>

                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 item">

                            <div className="card help-card">
                                    <i className="fa-solid fa-bitcoin-sign"></i>
                                    <h4>Multi Currency</h4>
                                    <p>Simplify your crypto portfolio management and store Bitcoin & ERC20 tokens under one seed phrase.</p>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 item">

                            <div className="card help-card">
                                <i className="bi bi-lightning-charge-fill"></i>
                                    <h4>Lightning Network</h4>
                                    <p>Experience instant and scalable Bitcoin payments through the integration of the Lightning Network. </p>
                            </div>
                        </div>


                        <div className="col-12 col-md-6 col-lg-4 item">

                            <div className="card help-card">
                                    <i className="icon icon-chart text-effect"></i>
                                    <h4>Lithium Protocol</h4>
                                    <p>Engage in instant and scalable ERC20 token transactions with the leading EVM off-chain protocol.</p>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 item">

                            <div className="card help-card">
                                    <i className="fa-solid fa-bridge"></i>
                                    <h4>Seamless bridging
</h4>
                                    <p>Bridge between diverse chains and ecosystems with our built-in bridge, providing the most cost-effective bridging solution.</p>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 item">

                            <div className="card help-card">
                                    <i className="fa-solid fa-mobile-screen-button"></i>
                                    <h4>Multi Device</h4>
                                    <p>Our Web wallet is accessible on any browser-enabled device, allowing for quick access and seed phrase creation in seconds.</p>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4 item">
                            <div className="card help-card">
                                <i className="fa-solid fa-file-invoice-dollar"></i>
                                    <h4>Invoice Generation</h4>
                                    <p>Generate invoices effortlessly with a single click, simplifying and streamlining your invoicing process.</p>
                            </div>
                        </div>
                    </div>
                </div>


            </section>



            <section id='comparison' className='bridge-section py-5'>




                <div className='container'>
                    <div className='row'>

                        <div className='col-lg-12'>
                            <div className='feature-column mb-5'>
                                <p className='sub-title'>WALLETS</p>
                                <h2>Comparison</h2>

                            </div>
                        </div>

                        <div className='col-lg-12 mb-5'>
                            <div className="compare-table table-responsive">
                                <table className="table table-striped">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th>COMPARE</th>
                                            <th>Hydranet Wallet</th>
                                            <th>Binance Wallet</th>
                                            <th>Metamask Wallet</th>
                                            <th>Trust Wallet</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Bitcoin Support</th>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">ERC20 Support</th>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Off-chain Support</th>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Invoice Payments</th>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Bridging</th>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="no fa-regular fa-circle-xmark"></i></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Desktop Support</th>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Mobile Support</th>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                            <td><i className="yes fa-regular fa-circle-check"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className='col-lg-5 mb-5 mb-lg-0'>
                            <div className='card-style-02'>
                                <h4>Fee Comparison</h4>
                                <p>
                                    Hydranet’s blockchain bridge stands out as the cheapest bridge in the crypto industry. Leveraging the Lithium protocol, gas fees are kept at a minimum, saving you money for your future investments.
                                </p>
                                <p>
                                    Experience seamless blockchain bridging without breaking the bank, only with Hydranet.

                                </p>
                            </div>

                        </div>
                        <div className='col-lg-7'>
                            <div className='card-style-02'>
                                <div className='row c-row g-0'>
                                    <label className='col-3'>Stargate</label>
                                    <div className="progress col-9" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: '95.18%' }}>665</div>
                                    </div>
                                </div>

                                <div className='row c-row g-0'>
                                    <label className='col-3'>Hope</label>
                                    <div className="progress col-9" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: '52%' }}>288</div>
                                    </div>
                                </div>

                                <div className='row c-row g-0'>
                                    <label className='col-3'>Celer</label>
                                    <div className="progress col-9" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: '38%' }}>243</div>
                                    </div>
                                </div>

                                <div className='row c-row g-0'>
                                    <label className='col-3'>Arbitrum Bridge</label>
                                    <div className="progress col-9" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: '32%' }}>157</div>
                                    </div>
                                </div>

                                <div className='row c-row g-0'>
                                    <label className='col-3'>Wormhole</label>
                                    <div className="progress col-9" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: '28%' }}>141</div>
                                    </div>
                                </div>

                                <div className='row c-row g-0'>
                                    <label className='col-3'>Across</label>
                                    <div className="progress col-9" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: '24%' }}>138</div>
                                    </div>
                                </div>

                                <div className='row c-row g-0'>
                                    <label className='col-3'>Hydranet</label>
                                    <div className="progress col-9" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar bg-info" style={{ width: '20%' }}>100</div>
                                    </div>
                                </div>



                                {/* <Barchart></Barchart> */}
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <section id='faqs' className='faqs-section py-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='feature-column mb-5'>
                                <p className='sub-title'>FAQs</p>
                                <h2>Learn More</h2>

                            </div>
                        </div>
                        <div className='col-lg-12'>
                            <div className="accordion accordion-flush accordion-faqs" id="accordion-faqs">
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-1" aria-expanded="true" aria-controls="flush-collapseOne">
                                            What stage is the Web Wallet at now?
                                        </button>
                                    </h2>
                                    <div id="flush-1" className="accordion-collapse collapse show" data-bs-parent="#accordion-faqs">
                                        <div className="accordion-body">
                                            The Web Wallet is currently in a testnet state with improvements of both the frontend and backend shipped every day.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-2" aria-expanded="false" aria-controls="flush-collapseTwo">
                                            How is it different from other Web3 wallets?

                                        </button>
                                    </h2>
                                    <div id="flush-2" className="accordion-collapse collapse" data-bs-parent="#accordion-faqs">
                                        <div className="accordion-body">
                                        Hydranet sets itself apart from other crypto wallets by integrating off-chain protocols such as the Lightning and Lithium Networks. By leveraging these protocols, Hydranet ensures Lightning-fast payments at minimal costs and enables cross-chain capabilities - always with full control over your funds.
                                        </div>
                                    </div>

                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-3" aria-expanded="false" aria-controls="flush-collapseThree">
                                            How do I test the Web Wallet?
                                        </button>
                                    </h2>
                                    <div id="flush-3" className="accordion-collapse collapse" data-bs-parent="#accordion-faqs">
                                        <div className="accordion-body">
                                            The wallet is available on testnet using this link: https://wallet.hydranet.ai/
                                            Testnet funds can be retrieved on Hydranet’s Discord: https://discord.gg/hydranet
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-4" aria-expanded="false" aria-controls="flush-collapseThree">
                                            Can assets be restored using another wallet?
                                        </button>
                                    </h2>
                                    <div id="flush-4" className="accordion-collapse collapse" data-bs-parent="#accordion-faqs">
                                        <div className="accordion-body">
                                            Your crypto assets are backed up by a 12 or 24 word seed phrase. You can restore your assets using another wallet by this seed phrase.
                                        </div>                                    
                                        </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-5" aria-expanded="false" aria-controls="flush-collapseThree">
                                        What kind of organization is Hydranet?
                                        </button>
                                    </h2>
                                    <div id="flush-5" className="accordion-collapse collapse" data-bs-parent="#accordion-faqs">
                                        <div className="accordion-body">
                                        Hydranet is a Decentralized Autonomous Organization (also known as a DAO). Hydranet doesn’t have a single owner or partner, instead it is a community-based formation that derives its strength from its community. The value of Hydranet is reflected by its token (HDN) alone.
                                        </div>                                    </div>
                                </div>
               
                            </div>

                        </div>
                    </div>
                </div>
            </section>


            <section id='contact' className='contact-section py-5'>
                <div className='container bg-1 mb-5'>
                    <div className='row align-items-center justify-content-center'>

                        <div className='col-lg-5 text-center'>
                            <img className='img-fluid' src={mobile} title='Hydranet Web3 Wallet' alt='Hydranet Web3 Wallet'></img>
                        </div>

                        <div className="col-lg-6 banner-content">
                            <h2 className="m-0">Join the Community</h2>
                            <p>Stay updated with the latest developments. Join the Hydranet Discord server and witness the revolution firsthand.</p>
                            <a className='button-default d-inline-flex' rel='noreferrer' href='https://discord.gg/hydranet' target='_blank' title='Hydranet Wallet Discord'>
                                <i className="fa-brands fa-discord"></i>Join Discord
                            </a>
                        </div>


                    </div>
                </div>
                <div className="social-icons d-flex justify-content-center pt-5 my-4">
                    <a className="twitter" rel='noreferrer' href="https://twitter.com/" target="_blank">
                        <i className="icon-social-twitter"></i>
                    </a>
                    <a className="discord" rel='noreferrer' href="https://discord.gg/hydranet" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 50 50">
                            <path d="M 18.90625 7 C 18.90625 7 12.539063 7.4375 8.375 10.78125 C 8.355469 10.789063 8.332031 10.800781 8.3125 10.8125 C 7.589844 11.480469 7.046875 12.515625 6.375 14 C 5.703125 15.484375 4.992188 17.394531 4.34375 19.53125 C 3.050781 23.808594 2 29.058594 2 34 C 1.996094 34.175781 2.039063 34.347656 2.125 34.5 C 3.585938 37.066406 6.273438 38.617188 8.78125 39.59375 C 11.289063 40.570313 13.605469 40.960938 14.78125 41 C 15.113281 41.011719 15.429688 40.859375 15.625 40.59375 L 18.0625 37.21875 C 20.027344 37.683594 22.332031 38 25 38 C 27.667969 38 29.972656 37.683594 31.9375 37.21875 L 34.375 40.59375 C 34.570313 40.859375 34.886719 41.011719 35.21875 41 C 36.394531 40.960938 38.710938 40.570313 41.21875 39.59375 C 43.726563 38.617188 46.414063 37.066406 47.875 34.5 C 47.960938 34.347656 48.003906 34.175781 48 34 C 48 29.058594 46.949219 23.808594 45.65625 19.53125 C 45.007813 17.394531 44.296875 15.484375 43.625 14 C 42.953125 12.515625 42.410156 11.480469 41.6875 10.8125 C 41.667969 10.800781 41.644531 10.789063 41.625 10.78125 C 37.460938 7.4375 31.09375 7 31.09375 7 C 31.019531 6.992188 30.949219 6.992188 30.875 7 C 30.527344 7.046875 30.234375 7.273438 30.09375 7.59375 C 30.09375 7.59375 29.753906 8.339844 29.53125 9.40625 C 27.582031 9.09375 25.941406 9 25 9 C 24.058594 9 22.417969 9.09375 20.46875 9.40625 C 20.246094 8.339844 19.90625 7.59375 19.90625 7.59375 C 19.734375 7.203125 19.332031 6.964844 18.90625 7 Z M 18.28125 9.15625 C 18.355469 9.359375 18.40625 9.550781 18.46875 9.78125 C 16.214844 10.304688 13.746094 11.160156 11.4375 12.59375 C 11.074219 12.746094 10.835938 13.097656 10.824219 13.492188 C 10.816406 13.882813 11.039063 14.246094 11.390625 14.417969 C 11.746094 14.585938 12.167969 14.535156 12.46875 14.28125 C 17.101563 11.410156 22.996094 11 25 11 C 27.003906 11 32.898438 11.410156 37.53125 14.28125 C 37.832031 14.535156 38.253906 14.585938 38.609375 14.417969 C 38.960938 14.246094 39.183594 13.882813 39.175781 13.492188 C 39.164063 13.097656 38.925781 12.746094 38.5625 12.59375 C 36.253906 11.160156 33.785156 10.304688 31.53125 9.78125 C 31.59375 9.550781 31.644531 9.359375 31.71875 9.15625 C 32.859375 9.296875 37.292969 9.894531 40.3125 12.28125 C 40.507813 12.460938 41.1875 13.460938 41.8125 14.84375 C 42.4375 16.226563 43.09375 18.027344 43.71875 20.09375 C 44.9375 24.125 45.921875 29.097656 45.96875 33.65625 C 44.832031 35.496094 42.699219 36.863281 40.5 37.71875 C 38.5 38.496094 36.632813 38.84375 35.65625 38.9375 L 33.96875 36.65625 C 34.828125 36.378906 35.601563 36.078125 36.28125 35.78125 C 38.804688 34.671875 40.15625 33.5 40.15625 33.5 C 40.570313 33.128906 40.605469 32.492188 40.234375 32.078125 C 39.863281 31.664063 39.226563 31.628906 38.8125 32 C 38.8125 32 37.765625 32.957031 35.46875 33.96875 C 34.625 34.339844 33.601563 34.707031 32.4375 35.03125 C 32.167969 35 31.898438 35.078125 31.6875 35.25 C 29.824219 35.703125 27.609375 36 25 36 C 22.371094 36 20.152344 35.675781 18.28125 35.21875 C 18.070313 35.078125 17.8125 35.019531 17.5625 35.0625 C 16.394531 34.738281 15.378906 34.339844 14.53125 33.96875 C 12.234375 32.957031 11.1875 32 11.1875 32 C 10.960938 31.789063 10.648438 31.699219 10.34375 31.75 C 9.957031 31.808594 9.636719 32.085938 9.53125 32.464844 C 9.421875 32.839844 9.546875 33.246094 9.84375 33.5 C 9.84375 33.5 11.195313 34.671875 13.71875 35.78125 C 14.398438 36.078125 15.171875 36.378906 16.03125 36.65625 L 14.34375 38.9375 C 13.367188 38.84375 11.5 38.496094 9.5 37.71875 C 7.300781 36.863281 5.167969 35.496094 4.03125 33.65625 C 4.078125 29.097656 5.0625 24.125 6.28125 20.09375 C 6.90625 18.027344 7.5625 16.226563 8.1875 14.84375 C 8.8125 13.460938 9.492188 12.460938 9.6875 12.28125 C 12.707031 9.894531 17.140625 9.296875 18.28125 9.15625 Z M 18.5 21 C 15.949219 21 14 23.316406 14 26 C 14 28.683594 15.949219 31 18.5 31 C 21.050781 31 23 28.683594 23 26 C 23 23.316406 21.050781 21 18.5 21 Z M 31.5 21 C 28.949219 21 27 23.316406 27 26 C 27 28.683594 28.949219 31 31.5 31 C 34.050781 31 36 28.683594 36 26 C 36 23.316406 34.050781 21 31.5 21 Z M 18.5 23 C 19.816406 23 21 24.265625 21 26 C 21 27.734375 19.816406 29 18.5 29 C 17.183594 29 16 27.734375 16 26 C 16 24.265625 17.183594 23 18.5 23 Z M 31.5 23 C 32.816406 23 34 24.265625 34 26 C 34 27.734375 32.816406 29 31.5 29 C 30.183594 29 29 27.734375 29 26 C 29 24.265625 30.183594 23 31.5 23 Z"></path>
                        </svg>
                    </a>
                    <a className="youtube" rel='noreferrer' href="https://youtube.com/@HydranetHDN" target="_blank">
                        <i className="icon-social-youtube"></i>
                    </a>
                    <a className="facebook" rel='noreferrer' href="https://www.facebook.com/HydranetOfficial" target="_blank">
                        <i className="icon-social-facebook"></i>
                    </a>
                    <a className="linkedin" rel='noreferrer' href="https://tr.linkedin.com/company/hydranet" target="_blank">
                        <i className="icon-social-linkedin"></i>
                    </a>
                    <a className="reddit" rel='noreferrer' href="https://www.reddit.com/r/hydranet/" target="_blank">
                        <i className="icon-social-reddit"></i>
                    </a>
                </div>

                <div className='col-lg-6 mx-auto'>
                    <nav className="main-menu navbar navbar-expand-md">

                        <div className="collapse navbar-collapse" id="navbarFooter">
                            <ul className="navbar-nav">
                                <li className="nav-item">

                                    <button className="nav-link" data-bs-toggle="modal" data-bs-target="#termsModal">Terms of Use</button>
                                </li>

                                <li className="nav-item">
                                    <a href='#features' className="nav-link" title='Features'>Features</a>
                                </li>
                                <li className="nav-item">
                                    <a href='#faqs' className="nav-link" title='FAQs'>FAQs</a>
                                </li>
                                <li className="nav-item">
                                    <a href='#comparison' className="nav-link" title='Comparison'>Comparison</a>
                                </li>

                            </ul>

                        </div>

                    </nav>

                </div>

                <div className='col-lg-8 mx-auto text-center'>
                    <p className='copyright'>©2024 Hydranet LTC, All Rights Reserved</p>
                </div>
            </section>



            <div className="modal fade" id="staticBackdrop" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content-lightbox">
                        <button type="button" className="lightbox-close" data-bs-dismiss="modal" aria-label="Close"></button>

                        <div className="modal-body">
                            <iframe id="player" width="100%" height="440" src="https://www.youtube.com/embed/0SKDEkaTXmE?si=vclbCNaslCIH1PuU" title="Hydranet Web3 Wallet" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                        </div>

                    </div>
                </div>
            </div>

            <div className="modal fade terms-modal" id="termsModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="termsModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="termsModalLabel">Terms of Use</h1>
                            <button type="button" className="button-close" data-bs-dismiss="modal" aria-label="Close"><i className="bi bi-x-lg"></i></button>
                        </div>
                        <div className="modal-body">
                            <div className="disclaimer-body"><h5> Hydranet / Hydranet Off-Chain LTC Disclaimer</h5><p>Please read this disclaimer carefully before using the Hydranet and Hydranet Off-Chain LTC Educational wallet pages (hereinafter referred to as "the wallet pages") provided by Hydranet / Hydranet Off-Chain LTC.</p><p><b>Educational Purpose Only:</b>The wallet pages have been developed for educational purposes only. They are designed to help users understand how decentralized autonomous organizations (DAOs) operate and how revenue allocation works within such entities. The wallet pages do not constitute financial, investment, or legal advice.</p><p><b>No Promise of Returns:</b>The use of the wallet pages does not imply or guarantee any returns on investment, financial gains, or revenue-sharing agreements. The wallet pages are purely theoretical models and should not be interpreted as a promise or assurance of any kind regarding financial outcomes.</p><p><b>No Investment Recommendation:</b>The wallet pages do not provide investment recommendations or strategies. Users should not make any financial decisions based solely on the results or information provided by the wallet pages. Any decision to invest or participate in DAOs should be made independently and after conducting thorough research and seeking appropriate advice.</p><p><b>Not a Financial Product:</b>The wallet pages are not a financial product, security, or investment instrument. They do not constitute an offer to sell or buy any tokens, assets, or financial instruments. Users should exercise caution and due diligence when considering any financial transactions.</p><p><b>No Liability:</b>Hydranet / Hydranet Off-Chain LTC. and its developers, contributors, and affiliates shall not be held liable for any direct or indirect losses, damages, or consequences resulting from the use or misuse of the wallet pages, including but not limited to financial losses or legal disputes.</p><p><b>Consultation with Professionals:</b>Users are strongly encouraged to seek advice from financial, legal, and tax professionals before making any investment decisions or participating in DAOs.</p><p><b>Disclaimer Changes:</b>Hydranet / Hydranet Off-Chain LTC. reserves the right to modify or update this disclaimer at any time without prior notice. Users are responsible for reviewing this disclaimer regularly for any changes.</p><p>By using the wallet pages, you acknowledge that you have read, understood, and agreed to this disclaimer. If you do not agree with any part of this disclaimer, please refrain from using the wallet pages.</p></div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}
